import { Icon } from './icon';

export const IconClose = () => (
  <Icon>
    <path d="M6 6L18.7742 18.7742" />
    <path d="M6 18.7742L18.7742 5.99998" />
  </Icon>
);
